<template>
  <view class="buy-ticket-card" wx:class="{{isDrawer && 'drawer'}}">
    <view class="buy-ticket-card-left" wx:class="{{{'normal-padding-top': buttonType === 0}}}">
      <image class="type-icon" src="{{buttonIcon}}" />
      <view>
        <view class="buy-ticket-type">
          <text class="type-writting">{{ purchaseType }}</text>
        </view>
        <view
          class="buy-ticket-description"
          wx:class="{{{'normal-padding-left': buttonType === 0}}}"
        >
          <block wx:if="{{ buttonType === 2 }}">
            <view class="scramble-description" wx:for="{{scrambleTextArr}}">
              <image
                class="scramble-description-icon"
                src="https://ut-static.udache.com/webx/sfc/O9Uo8R6LvK2QT9gNDMOSp.png"
              />
              <view class="scramble-description-text">{{ item }}</view>
            </view>
          </block>
          <block wx:else>
            <view class="buy-ticket-description-left">{{ leftDescription }}</view>
            <view class="buy-ticket-description-right" wx:if="{{rightDescription}}">
              <text>{{ rightDescription }}</text>
              <image
                wx:if="{{buttonType === 1}}"
                class="question-mark"
                src="https://img-hxy021.didistatic.com/static/starimg/img/xA27RuQfHS1691684676038.png"
                bindtap="getServiceDescription"
              />
            </view>
          </block>
        </view>
      </view>
    </view>
    <view class="buy-ticket-card-right" bindtap="buyTicket">
      <view class="ticket-price-area">
        <view class="ticket-price"
          ><text wx:style="{{ {fontSize: '16px', marginRight: '2px' }}}">¥</text>{{ showPrice }}</view
        >
        <!-- 优惠信息 -->
        <view wx:if="{{discountDesc}}" class="discount-desc">{{ discountDesc }}</view>
      </view>
      <view
        class="card-button"
        wx:style="{{canTap ? '':'background: #CCCCCC'}}"
        >{{ btnText }}</view
      >
    </view>
  </view>
  <privacy-toast
    wx:if="{{showPrivacy}}"
    list="{{privacyList}}"
    bind:privacyVerify="privacyVerify"
  />
</template>

<style lang="stylus" scoped>
  @import '~@/mixins/stylus/color.styl'

  .buy-ticket-card
    display flex
    justify-content space-between
    align-items center
    padding 24px 0 23px
    // border-radius 8px
    // box-sizing border-box
    // background #ffffff
    // margin-bottom 10px
    &.drawer
      background #F6F9FD
      border-radius 10px
      padding-left 10px
      padding-right 12px
      margin-left -4px
      margin-right -4px
    .type-icon
      height 33px
      width 33px
      margin-right 6px
    .buy-ticket-card-left
      display flex
      // flex-direction column
      // justify-content space-between
      align-items center
      padding-top 1px
      box-sizing border-box
      .buy-ticket-type
        height 20px
        line-height 20px
        display flex
        align-items center
        position relative
        color #000000
        font-family PingFangSC-Medium
        margin-bottom 4px
        .type-writting
          font-size 16px
      .buy-ticket-description
        display flex
        height 13px
        line-height 13px
        font-size 12px
        font-family PingFangSC-Regular
        color #666
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
        .scramble-description
          height 16px
          display flex
          align-items center
          &:not(:last-child)
            margin-right 2px
          &-icon
            height 4px
            width 6px
            margin-right 2px
          &-text
            font-family PingFangSC-Regular
            font-size 12px
            line-height 14px
            color #666
        .buy-ticket-description-right
          display flex
          margin-left 12px
          position relative
          .question-mark
            margin-left 2px
            height 12px
            width 12px
          &::after
            content ''
            height 8px
            border 0.5px solid rgba(153, 153, 153, 0.7)
            position absolute
            top 50%
            left -6px
            transform translateY(-50%)
      .normal-padding-left
        padding-left 2px
    .normal-padding-top
      padding-top 3px
    .buy-ticket-card-right
      display flex
      align-items center
      .ticket-price-area
        color #FF6400
        display flex
        align-items flex-end
        flex-direction column
        min-width 58px
        .ticket-price
          height 24px
          line-height 24px
          font-size 22px
          font-family Barlow Semi Condensed
          font-weight 400
        .discount-desc
          font-family PingFangSC-Regular
          font-size 9px
          font-weight normal
          line-height 9px
          padding 1.5px
          border-radius 3px
          box-shadow 0px 0px 0px 0.5px #FFBC91
      .card-button
        margin-left 8px
        height 40px
        line-height 40px
        text-align center
        width 40px
        color #fff
        border-radius 10px
        background #FF6400
        font-size 16px
        font-family PingFangSC-Semibold
</style>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { getStorage, setStorage } from '@/utils/storage'
  import { getFinalPrice } from '@/utils/money'
  import initMixin from '@/mixins'
  import { STORAGE_LIST_SEARCH_QUERY } from '@/utils/train-storage'
  import { LOAD_FAIL_CONTENT } from '@/common/constant'
  import { innerRouter, pagePath } from '@/common/jump'
  import { to12306LoginPage } from '@/common/pageJump'
  import { postSign } from '../privacy/api'
  import { xenv, getURL } from '@didi/webx-js'
  import { trackEvent } from '@/common/track'
  createComponent({
    mixins: [initMixin],
    props: {
      from: String,
      privacyList: {
        type: Object,
        value: {},
      },
      buttonType: {
        type: Number,
        value: 0,
      }, // 按钮应用场景 0正常购买 1便携购买 2抢票 3预约抢票
      trackParams: {
        type: Object,
        value: {},
      },
      isDrawer: {
        type: Boolean,
        value: false,
      }, // 是否用于投票弹窗中
      drawerPrice: {
        type: Number,
        value: 0,
      }
    },
    watch: {
      curSeatType: {
        immediate: true,
        handler(val, old) {
          if (val !== old) {
            if (this.buttonType === 0)
              trackEvent(
                'userteam_train_trainnum_order_sw',
                'UT-火车票-车次详情-预定/抢票-展现',
                {
                  ...this.trackParams,
                }
              )
            else if (this.buttonType === 2)
              trackEvent(
                'userteam_train_trainnum_order_sw',
                'UT-火车票-车次详情-预定/抢票-展现',
                {
                  type: 'snatch',
                }
              )
          }
        },
      },
    },
    data: {
      showPrivacy: false, // 是否展示隐私协议弹窗
      scrambleTextArr: ['余票监控','官方候补','改退无忧']
    },
    computed: {
      ...store.mapState({
        selectSeatInfo: 'train.selectSeatInfo',
        trainListInfo: 'train.trainListInfo',
        trainInfo: 'train.trainInfo',
        isTransfer: 'train.isTransfer',
        ticketData: 'train.ticketData'
      }),
      ...store.mapGetters({
        travelInfo: 'travel.travelInfo', // 存起来的当前差旅
      }),
      offlineHandingFee() {
        const price = this.selectSeatInfo.reduce(
          (tot, cur) => tot + Number(cur?.offline_handing_fee || 0),
          0
        )
        return this.buttonType === 1 && price ? getFinalPrice(price) : 0
      },
      isHasSeat() {
        const _isHasSeat =  this.selectSeatInfo?.every(item => item?.ticket_num !== '无票')
        return _isHasSeat
      },
      btnText(){
        switch (this.buttonType) {
          case 0 , 1:
            return '订'
          case 2 , 3:
            return '抢'
          default:
            return '订'
        }
      },
      bookingType() {
        const trainListSearchQuery = getStorage(STORAGE_LIST_SEARCH_QUERY) || {}
        const { booking_type } = trainListSearchQuery
        return booking_type
      },
      purchaseType() {
        switch (this.buttonType) {
          case 0:
            return '12306购票'
          case 1:
            return '滴滴便捷购票'
          case 2:
            return '极速抢票'
          case 3:
            return '预约抢票'
          default:
            return ''
        }
      },
      buttonIcon() {
        switch (this.buttonType) {
          case 0:
            return 'https://dpubstatic.udache.com/static/dpubimg/1vw5FK-7ApC1x3WspChRT.png'
          case 1:
            return 'https://dpubstatic.udache.com/static/dpubimg/SAgdqR9NYX3G-eEujEi02.png'
          case 2:
            return 'https://dpubstatic.udache.com/static/dpubimg/00kn2ot-Ln39j7WlZvl-b_pic-12306.png'
          case 3:
            return 'https://ut-static.udache.com/webx/sfc/oIWB5tVF4XNPfTJ0BvGts.png'
          default:
            return ''
        }
      },
      leftDescription() {
        switch (this.buttonType) {
          case 0:
            return '官方免费直购'
          case 1:
            return '免登12306'
          case 3:
            return '开售自动抢，先人一步抢到票'
          default:
            return ''
        }
      },
      rightDescription() {
        switch (this.buttonType) {
          case 0:
            return '需登录12306账号'
          case 1:
            return `已含${this.offlineHandingFee}元服务费`
          default:
            return ''
        }
      },
      curTransferIndex() {
        return this.ticketData?.[1]?.findIndex(ticket => ticket.seat_type_name === this.selectSeatInfo?.[1]?.seat_type_name) ?? 0
      },
      price() {
        let _price
        if(this.isTransfer) {
          switch (this.buttonType) {
            case 0:  // 普通
              const login12306 = this.selectSeatInfo[0]?.union_all_type_channels_coupon?.login12306?.[this.curTransferIndex]
              _price = login12306?.coupon_after_union_all_price || login12306?.coupon_union_all_price || 0 
              break
            case 1:  // 免登
              const offline = this.selectSeatInfo[0]?.union_all_type_channels_coupon?.offline?.[this.curTransferIndex]
              _price = offline?.coupon_after_union_all_price || offline?.coupon_union_all_price || 0
              break
          }
        }
        else {
          switch (this.buttonType) {
            case 0:  // 普通
              _price = this.selectSeatInfo[0]?.all_type_channels_coupon?.login12306?.coupon_after_price
              break
            case 1:  // 免登
              _price = this.selectSeatInfo[0]?.all_type_channels_coupon?.offline?.coupon_after_price
              break
            default:
              _price = this.selectSeatInfo[0]?.coupon_after_price
              break
          }
        }
        _price = Number(_price || this.selectSeatInfo?.reduce((acc, cur) => acc + Number(cur.ticket_price ?? 0), 0) || 0)
        if (!_price) return '--'
        const ticket_price = getFinalPrice(_price) || 0
        const service_price = this.offlineHandingFee
        return `${ticket_price + service_price}`
      },
      showPrice() {
        return this.price
        // return this.isDrawer ? this.drawerPrice : this.price
      },
      // 券透传信息 - 减多少钱
      discountDesc() {
        let desc
        if(this.isTransfer) {
          switch (this.buttonType) {
            case 0:  // 普通
              desc = this.selectSeatInfo[0]?.union_all_type_channels_coupon?.login12306?.[this.curTransferIndex]?.discount_desc
              break
            case 1:  // 免登
              desc = this.selectSeatInfo[0]?.union_all_type_channels_coupon?.offline?.[this.curTransferIndex]?.discount_desc
              break
          }
        }
        else {
          switch (this.buttonType) {
            case 0:  // 普通
              desc = this.selectSeatInfo[0]?.all_type_channels_coupon?.login12306?.discount_desc
              break
            case 1:  // 免登
              desc = this.selectSeatInfo[0]?.all_type_channels_coupon?.offline?.discount_desc
              break
            default:
              desc = this.selectSeatInfo[0]?.all_type_channels_coupon?.scramble?.discount_desc
              break
          }
        }
        return desc
      },
      curSeatType() {
        // todo jzj 埋点需要修改
        return this.selectSeatInfo[0]?.seat_type_name || ''
      },
      canTap() {
        const hasPrice = this.selectSeatInfo?.every((item) => item && item.ticket_price)
        return hasPrice && (this.isHasSeat || this.buttonType === 2 || this.buttonType === 3)
      }
    },
    methods: {
      ...store.mapMutations({
        setMakeOrderLoginType: 'makeOrder.setMakeOrderLoginType',
        setTrainDetailRefreshFlag: 'train.setTrainDetailRefreshFlag',
      }),
      ...store.mapActions({
        getCurrentUserReverse: 'login12306.getCurrentUserReverse'
      }),
      buyTicket() {
        // 不可预定点击
        if (!this.canTap) {
          return
        }
        if(this.isDrawer) this.triggerEvent('close')
        // 埋点
        this.$trigger('reportClick', this.buttonType)
        if (this.privacyList?.title) {
          // 有待签署协议，需要展示签署弹窗
          this.showPrivacy = true
        } else {
          this.setTrainDetailRefreshFlag(false)
          // 校验12306登录状态
          this.fetchUserReverse()
        }
      },
      fetchUserReverse() {
        // 快捷购票跳转  0代表用户走12306逻辑 1代表免登逻辑
        if(this.isDrawer) return this.triggerEvent('check')
        if (this.buttonType === 1) {
          this.setMakeOrderLoginType(1)
          return innerRouter.push(pagePath().MAKEORDER, {
            booking_type: this.bookingType,
            from: this.from,
          })
        }
        const isOverDue =
          new Date(this.trainInfo.start_time) - new Date() < 1800000
        if (this.buttonType === 2 && isOverDue) {
          return mpx.showToast({
            title: '距离发车时间较近，请重新选择',
            duration: 3500,
            icon: 'error',
          })
        }
        if(this.buttonType === 0) {
          this.setMakeOrderLoginType(0)
          return innerRouter.push(pagePath().MAKEORDER, {
            booking_type: this.bookingType,
            from: this.from,
          })       
        }
        const startTimeLog = new Date().getTime()
        this.getCurrentUserReverse()
          .then(res => {
            const { data, success, message, code } = res || {}
            const endTimeLog = new Date().getTime()
            const deltaTimeLog = endTimeLog - startTimeLog
            trackEvent(
                'userteam_train_reverse_time',
                'UT-火车票-预定校验-接口耗时',
                {
                  deltaTime:deltaTimeLog
                }
              )
            if (success) {
              if (code === '0') {
                if(getURL()?.indexOf('train-detail') === -1) return
                const { is_login } = data || {}
                if (!is_login) {
                  to12306LoginPage({
                    isPre: 'preTicket',
                    cxvip: 'popup'
                  })
                } else {
                  this.setMakeOrderLoginType(0)
                  innerRouter.push(pagePath().MAKEORDER, {
                    booking_type: this.bookingType,
                    from: this.from,
                    order_type: !this.isHasSeat || this.buttonType === 3 ? 'scramble' : '',
                  })
                }
              } else {
                mpx.showToast({
                  title: message || LOAD_FAIL_CONTENT, //提示的内容,
                  icon: 'error', //图标,
                })
              }
              //12306默认返回1 航天根据状态返回 0 或者 1
            } else {
              mpx.showToast({
                title: LOAD_FAIL_CONTENT, //提示的内容,
                icon: 'success', //图标,
              })
            }
          })
          .finally(() => {
            mpx.hideLoading()
          })
      },
      privacyVerify(val) {
        const isComfirm = val.detail
        this.showPrivacy = false
        if (isComfirm) {
          this.$trigger('resetPrivacyList')
          // 已成功签署
          this.setTrainDetailRefreshFlag(false)
          // 校验12306登录状态
          this.fetchUserReverse()
        }
      },
      getServiceDescription() {
        this.$trigger('getServiceDescription')
      },
    },
  })
</script>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'privacy-toast': '../privacy'
    }
  }
</script>
